module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Background</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\" >\r\n        <input id=\"backgroundColorPicker\" name=\"backgroundColor\" type=\"color\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"backgroundColor\" name=\"backgroundColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-5 nopadding\" >\r\n        <input id=\"bgGradientColorPicker\" name=\"bgGradientColor\" type=\"color\" value=\"")
    ; __append(escapeFn( bgGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"bgGradientColor\" name=\"bgGradientColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( bgGradientColor ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}